/**
 * Pre-compiled localized messages for Select component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import selectMessages_en from "./intl/en";
import selectMessages_de from "./intl/de";
import selectMessages_es from "./intl/es";
import selectMessages_fr from "./intl/fr-FR";
import selectMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const selectMessagesStrings: LocalizedStrings<string, LocalizedString> =
  {
    en: normalizeMessages(selectMessages_en),
    de: normalizeMessages(selectMessages_de),
    es: normalizeMessages(selectMessages_es),
    "fr-FR": normalizeMessages(selectMessages_fr),
    "pt-BR": normalizeMessages(selectMessages_pt),
  } as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Select component
 */
export type SelectMessageKey = "clearSelection";
